<template>
    <router-link v-if="isAdvanced" :to="link" class="text-decoration-none d-flex pl-3 align-center">
        <slot></slot>
    </router-link>
    <a v-else :href="link" target="_blank" class="text-decoration-none d-flex pl-3 align-center">
        <slot></slot>
    </a>
</template>

<script>
export default {
    props: ['isAdvanced', 'link']
}
</script>

<style>

</style>